var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08984 0.5C10.7221 0.5 13.6768 3.45781 13.6768 7.09082C13.6767 8.71777 13.0813 10.2057 12.0986 11.3574L11.7988 11.709L17.4805 17.3906C17.4866 17.3965 17.4918 17.4035 17.4951 17.4111C17.4984 17.4188 17.4999 17.4272 17.5 17.4355C17.5001 17.4439 17.4982 17.4522 17.4951 17.46C17.4919 17.4678 17.4874 17.4754 17.4814 17.4814C17.4755 17.4874 17.4678 17.4919 17.46 17.4951C17.4523 17.4982 17.4439 17.5001 17.4355 17.5L17.4111 17.4951C17.4032 17.4917 17.3964 17.4864 17.3906 17.4805L17.3828 17.4727L12.0352 12.126L11.708 11.7988L11.3564 12.0986C10.2047 13.0813 8.71673 13.6777 7.08984 13.6777C3.45726 13.6776 0.500233 10.7229 0.5 7.09082C0.5 3.45822 3.45742 0.500172 7.08984 0.5ZM7.08984 0.625C3.51296 0.625171 0.625 3.51385 0.625 7.09082C0.625232 10.6676 3.51311 13.5555 7.08984 13.5557C10.6671 13.5557 13.5525 10.6673 13.5527 7.09082C13.5527 3.5141 10.6672 0.625 7.08984 0.625Z",
    fill: "#003032",
    stroke: "#003032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.63ed5a473ae5587bd448fc06fb848acf.svg";
export { ForwardRef as ReactComponent };